module.exports = __webpack_public_path__ + "static/media/nfl_collage.3860651b.jpg";